module.exports = __webpack_public_path__ + "static/img/cePath5.d6587f8d.gif";